import CryptoJS from 'crypto-js' // 引入crypto

const key = CryptoJS.enc.Utf8.parse('4hXnn8NUtss5OUTR')

export default {
	//1接受一个明文对象
	//2返回一个 word:{加密字符串}的对象
	aesEncryptObj2Obj(obj) { // 加密	
		let word = JSON.stringify(obj)
		let srcs = CryptoJS.enc.Utf8.parse(word)
		let encrypted = CryptoJS.AES.encrypt(srcs, key, {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		}) // 加密模式为ECB，补码方式为PKCS5Padding（也就是PKCS7）

		let jsObj = {}
		jsObj.word = encrypted.toString()
		return jsObj //
	},

	//1接受一个加密字符串
	//2返回一个明文字符串或对象	
	aesDecryptText(word) { // 解密	
		let jsObj
		if (word !== '') {
			let decrypt = CryptoJS.AES.decrypt(word, key, {
				mode: CryptoJS.mode.ECB,
				padding: CryptoJS.pad.Pkcs7
			})
			let str = CryptoJS.enc.Utf8.stringify(decrypt).toString()
			try {
				jsObj = JSON.parse(str)
			} catch (e) {
				jsObj = str
			}
		}
		return jsObj
	},

}
